
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import MobileOptionsSelectedOptionsItem from '@/components/Options/MobileOptionsSelectedOptionsItem.vue';
import OptionsData from '@/ts/OptionsData';

@Component({
    components: {
        MobileOptionsSelectedOptionsItem,

    },
})
export default class MobileOptionsSelectedOptions extends Vue {

    @Prop() public items!: OptionsData;

    constructor() {
        super();
    }

    get getTempData(): any {
        return this.$store.getters['Options/allOptions'];
    }

    public GOBACKNOW() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Options,
            viewMode: ViewModes.Options.All,
        });
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.your-selections', 'Your selections'));
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, 'BackButton');
    }

    public beforeUpdate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.your-selections', 'Your selections'));
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, 'BackButton');
    }
}
